import { Spinner } from "components/spinner/spinner";
import { LINES } from "libs/colors";
import { ProductItemModel } from "libs/models/batch-model";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, ApplicationState } from "store";
import { setProductOperationsProps } from "store/slices/product-operations";
import { formatNumber } from "utils/numbers";
import { removeUnnecessaryZeros } from "utils/shared";
import translate from "utils/translations";
interface RedeemProps {
  validateRedemption: () => void;
  cancelRedemption: () => void;
  disabled: boolean;
  balance: string;
}
export const RedeemBox = ({
  validateRedemption,
  cancelRedemption,
  disabled,
  balance,
}: RedeemProps) => {
  const redeemRef = useRef<HTMLInputElement>(null);
  const redemptionAmount = useSelector(
    (state: ApplicationState) => state.productoperations.redemptionAmount
  );
  const actionLoading = useSelector(
    (state: ApplicationState) => state.productoperations.actionLoading
  );
  const dispatch = useDispatch<AppDispatch>();
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    dispatch(
      setProductOperationsProps({
        key: name,
        value: value,
      })
    );
  };
  useEffect(() => {
    redeemRef.current?.focus();
  }, []);

  return (
    <div className="rounded-2xl ring-1 ring-slate-200 bg-white p-5 mt-3">
      <div>
        <div className="flex items-center justify-between">
          <label className="block text-sm font-medium text-slate-700 mb-2">
            {translate("Redeem_Text", "Redeem TODO")}
          </label>
          <label
            className="block text-sm font-medium text-red-700 mb-2 cursor-pointer"
            onClick={cancelRedemption}
          >
            {translate("Cancel_Text", "Cancel TODO")}
          </label>
        </div>
        <div className={`w-full h-[3px] bg-slate-200 rounded-l mb-2`} />
        <label className="block text-sm font-medium text-slate-700 mb-1">
          {translate("Redemption_Value_Text", "Redemption Value")}
        </label>
        <input
          type="number"
          inputMode="numeric"
          ref={redeemRef}
          placeholder={translate("Enter_Amount_Text", "Enter Amount")}
          value={redemptionAmount}
          name="redemptionAmount"
          onInput={removeUnnecessaryZeros}
          onChange={onChange}
          className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-base shadow-inner focus:outline-none focus:ring-4 focus:ring-emerald-200 disabled:opacity-50"
          min={0}
          step={1}
          disabled={disabled}
          aria-describedby="redeem-hint"
        />
        <p id="redeem-hint" className="mt-1 text-xs text-slate-500 mt-3">
          <div className="w-full h-8 bg-slate-200 rounded overflow-hidden">
            <div
              className="h-8 bg-emerald-600"
              style={{
                width: `${(Number(redemptionAmount) / Number(balance)) * 100}%`,
              }}
            />
          </div>
          {formatNumber(Number(redemptionAmount))} /{" "}
          {formatNumber(Number(balance))}
        </p>

        <button
          type="button"
          className="mt-3 h-11 w-full rounded-xl bg-emerald-600 text-white font-semibold shadow hover:bg-emerald-700 focus:outline-none focus-visible:ring-4 focus-visible:ring-emerald-200 disabled:opacity-50"
          onClick={() => validateRedemption()}
          disabled={disabled || actionLoading !== null}
          aria-busy={actionLoading === "redeem"}
        >
          {actionLoading === "redeem" ? (
            <Spinner label="Redeeming" />
          ) : (
            translate("Redeem_Text", "Redeem")
          )}
        </button>
      </div>
    </div>
  );
};
